import { render, staticRenderFns } from "./OssDownload.vue?vue&type=template&id=4a5c3120"
import script from "./OssDownload.vue?vue&type=script&lang=ts"
export * from "./OssDownload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports